'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FirstChild',

  propTypes: {
    children: _react.PropTypes.node.isRequired
  },

  render: function render() {
    // All the wrapper component does is return its first child passed in to it.
    // Its main purpose is to prevent CSSTransitionGroup from adding a <span>:
    // facebook.github.io/react/docs/animation.html#rendering-a-single-child
    var children = this.props.children;

    var childrenArray = _react2.default.Children.toArray(children);
    if (childrenArray.length > 1) {
      /* eslint-disable no-console */
      console.warn('FirstChild was given multiple children, but can only render one.');
      /* eslint-enable no-console */
    }
    return childrenArray[0];
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/utils/FirstChild.js
// module id = 321
// module chunks = 0